module.exports = __webpack_public_path__ + "media/reskin-images/icon--calendar-2-c1349daa.svg";